import React, { useState } from 'react';

import Chart from './Chart';
import Picker from './Picker';
import Settings from './Settings';

import './App.css';

import type { Series } from './series';

function App() {
  const [series, setSeries] = useState<Series[] | []>([]);
  const [minYear, setMinYear] = useState(1913);

  const onChange = (vals: Series[]) => {
    setSeries(vals);
  };

  const onYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = parseInt(e.target.value, 10);
    if (Number.isInteger(val)) {
      setMinYear(val);
    }
  };

  return (
    <div className="App">
      <header className="App-header">
        {/*<h1>Compare inflation rates</h1>*/}
        <Picker onChange={onChange} />
      </header>
      <div>
        <Chart series={series} userMinYear={minYear} />
      </div>
      <Settings minYear={minYear} onYearChange={onYearChange} />
      {/*
      <div className="footer">
        <a href="/">&laquo; Back to Inflation Calculator</a>
      </div>
      */}
    </div>
  );
}

export default App;
